export default {
  cancellation_months: 1,
  membership: {
    calculated_end_date: new Date(2020, 1, 1),
  },
}
